import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import '@style/Tab.scss';

const SNSList = () => {
  const { t, i18n } = useTranslation();

  return (
    <section className="pb-[5%] pt-[10px] sns-list landscape:pb-[60px] ">
      <div className="font-extrabold font-TmoneyRoundWind text-center tracking-[-1px]">
        <div className=" ">
          <div className="mt-5 flex justify-around ">
            <a href="https://twitter.com/INTHESEOM_BTS" target="_blank">
              <img
                src="/img/media/twitter.svg"
                alt=""
                className="w-[33px] h-[25px] m-auto mt-[-2px]"
              />
            </a>

            <a href="https://twitter.com/BTSINTHESEOM_JP" target="_blank">
              <img
                src="/img/media/twitter-jp.png"
                alt=""
                className=" h-[20px]  m-auto mt-[2px]"
              />
            </a>

            <a href="https://www.instagram.com/intheseom_bts" target="_blank">
              <img
                src="/img/media/instagram.svg"
                alt=""
                className="w-[33px] h-[25px]  m-auto"
              />
            </a>
            <a href="https://www.facebook.com/INTHESEOM.BTS" target="_blank">
              <i className="facebook">
                <img
                  src="/img/media/facebook_v2.svg"
                  className="w-[33px] h-[44px]  m-auto mt-[-9px]"
                />
              </i>
            </a>
            <a
              href="https://youtube.com/channel/UCh7AOH7ar_5F90b7A2Yse7w"
              target="_blank"
            >
              <img
                src="/img/media/youtube.svg"
                alt=""
                className="w-[28px] h-[25px] m-auto"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default observer(SNSList);
